import {remCalc} from '../../_utils'

const getSideCardStyles = (
    backgroundColor: 'white' | 'black' | 'grey' = 'white',
    hasPaddings: boolean,
    isPdpPage: boolean,
    isFull: boolean,
    isReversed: boolean,
    isSmallTablet: boolean,
    hasDetails: boolean,
    isExpanded: boolean,
) => {
    const colors = {
        backgroundColor: isPdpPage
            ? 'background.default'
            : backgroundColor === 'grey'
            ? 'background.light'
            : backgroundColor === 'black'
            ? 'background.dark'
            : 'background.default',
        label: {
            color: backgroundColor === 'black' ? 'text.inverse' : 'text.secondary',
        },
        text: {
            color: backgroundColor === 'black' ? 'text.inverse' : 'text.default',
        },
        buttonVariant: backgroundColor === 'black' ? 'inverse-secondary' : 'secondary',
        socialIconsBorders:
            backgroundColor === 'black'
                ? {
                      borderWidth: `${remCalc(1)}`,
                      borderStyle: 'solid',
                      borderRadius: `${remCalc(10)}`,
                      borderColor: 'rgba(255, 255, 255, 0.3)',
                  }
                : undefined,
    }

    const styles = {
        ...colors,
        container: {
            backgroundColor: colors.backgroundColor,
            maxWidth: remCalc(1920),
            margin: '0 auto',
        },
        horizontalContainer: {
            alignItems: 'center',
            justifyContent: isFull ? (isReversed ? 'flex-end' : 'flex-start') : 'center',
            py: hasPaddings ? {md: remCalc(24), lg: remCalc(40)} : undefined,
        },
        horizontalOutterContent: {
            px: isFull || isPdpPage ? undefined : remCalc(24),
            gap: isFull ? remCalc(142) : isPdpPage ? undefined : remCalc(24),
            justifyContent: isFull ? undefined : 'space-between',
            direction: isReversed ? 'row-reverse' : 'row',
            alignItems: {
                md: isPdpPage ? 'stretch' : 'center',
                lg: 'center',
            },
            height: 'fit-content',
            maxWidth: isFull ? undefined : remCalc(1440),
            width: '100%',
        },
        horizontalImageContainer: {
            aspectRatio: isPdpPage && '1.367 / 1',
            width: isPdpPage ? '100%' : 'fit-content',
            maxWidth: isPdpPage && remCalc(807),
        },
        verticalImageContainer: {
            mb: remCalc(16),
            aspectRatio: isPdpPage && '1.367 / 1',
            width: isPdpPage && '100%',
        },
        horizontalInnerContent: {
            minWidth: isPdpPage ? {md: remCalc(476), lg: '30%'} : remCalc(451),
            maxWidth: isPdpPage
                ? {md: remCalc(476), lg: `calc(100% - ${remCalc(973)})`}
                : {lg: remCalc(332)},
            ml: isPdpPage && {md: remCalc(24), lg: isReversed ? remCalc(24) : remCalc(142)},
            mr: isPdpPage && {md: remCalc(24), lg: isReversed ? remCalc(142) : remCalc(24)},
        },
        verticalContainer: {
            direction: 'column',
            alignItems: 'center',
            py: hasPaddings
                ? isPdpPage
                    ? remCalc(16)
                    : {base: remCalc(24), md: remCalc(40)}
                : {base: remCalc(24), lg: 'inherit'},
        },
        verticalOutterContent: {
            direction: {
                base: 'column',
                md: isPdpPage ? (isReversed ? 'row-reverse' : 'row') : 'column',
            },
            alignItems: hasDetails ? 'flex-start' : 'center',
            mx:
                isSmallTablet && !hasDetails
                    ? remCalc(85)
                    : hasDetails
                    ? remCalc(24)
                    : {base: remCalc(16), md: remCalc(107)},
        },
        socialIconsContainer: {
            gap: remCalc(16),
            direction: {base: 'column', md: 'row'},
            alignItems: 'center',
            justifyContent: {base: 'center', lg: 'flex-start'},
        },
        verticalDetailedFullSizePdp: {
            position: 'relative',
            alignItems: 'center',
            marginTop: remCalc(16),
        },
        verticalDetailedPdp: {
            position: 'relative',
            transition: 'all .2s ease-in-out',
            overflow: 'hidden',
            alignItems: 'center',
            _after: {
                content: "''",
                position: 'absolute',
                top: !isExpanded ? '0' : 'unset',
                left: !isExpanded ? '0' : 'unset',
                right: !isExpanded ? '0' : 'unset',
                bottom: !isExpanded ? '0' : 'unset',
                bg: 'linear-gradient(180deg, rgba(255,255,255,0), rgba(255,255,255,1))',
                opacity: !isExpanded ? '1' : '0',
                transition: 'all .2s ease-in-out',
            },
        },
        toggleButton: {
            mt: remCalc(16),
            px: '0',
            py: '0',
            height: 'auto',
        },
    }
    return styles
}

export default getSideCardStyles
